import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-banknote-template-info',
  imports: [TranslatePipe],
  templateUrl: './banknote-template-info.component.html',
  styleUrls: [
    './banknote-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class BanknoteTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'banknote.';
}
